import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=9add5e6a"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=9add5e6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports